import Vue from 'vue'
import Vuex from 'vuex'
import settings from './modules/settings'
import filters from './modules/filters'
import search from './modules/search'
import vehicles from './modules/vehicles'
import compare from './modules/compare'
import layout from './modules/layout'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    settings,
    filters,
    search,
    vehicles,
    compare,
    layout
  },
  strict: debug
})
